import * as z$1 from "zod/v4";
//#region src/schemas/protocol/center-agent-interaction-source.ts
const CENTER_AGENT_INTERACTION_CLIENT_MAX_CHARS = 80;
const CENTER_AGENT_INTERACTION_SESSION_ID_MAX_CHARS = 512;
/**
* Describes the authenticated client's carrier for a Center Agent request.
* This is attribution and trace context only. It never grants identity,
* membership, data access, or execution authority.
*/
const centerAgentInteractionSourceSchema = z$1.discriminatedUnion("kind", [z$1.strictObject({
	client: z$1.string().trim().min(1).max(80),
	kind: z$1.literal("local_agent"),
	sessionId: z$1.string().trim().min(1).max(512).optional()
})]);
//#endregion
export { CENTER_AGENT_INTERACTION_CLIENT_MAX_CHARS, CENTER_AGENT_INTERACTION_SESSION_ID_MAX_CHARS, centerAgentInteractionSourceSchema };

//# sourceMappingURL=center-agent-interaction-source.js.map